// extracted by mini-css-extract-plugin
export default {"Root":"MultiFactor_Root__PC2y1","Buttons":"MultiFactor_Buttons__712nB","Horizontal":"MultiFactor_Horizontal__Exie6"};